import { useEffect } from "react";
import { useSurge } from "../../../hooks/useCases/useSurge";
import { useStylesMUI } from "../../../styles/home/style";
import { TemplateABM } from "../../atomic/templates/TemplateABM";
import { ValidatorInputField } from "../../atomic/atoms/Inputs";
import { exactLength, onlyDecimals, onlyNumbers, required } from "../../../helpers/validations/validators";
import { SelectValidatorGeneric } from "../../atomic/atoms/Select";

export const AbmPracticasYDispositivos = () => {
    const classes = useStylesMUI();
    const surge = useSurge();

    useEffect(() => {
        surge.getAll.practicasYDispositivos();
        surge.getAll.conceptos();
        surge.getAll.resoluciones();
    }, []);

    return (
      <div className={classes.root}>
        <TemplateABM
          titles={{
            abm: 'Practicas y Dispositivos SUR',
            insert: 'Agregar Practica y Dispositivo',
            update: 'Modificar Practica y Dispositivo',
            delete: 'Eliminar Practica y Dispositivo',
          }}
          data={(data) => ({
            id: data?.idPracticaDispositivo || "",
            conceptoSurge: data?.conceptoSurge || "",
            resolucionSurge: data?.resolucionSurge || "",
            valor: data?.valor || "",
            periodo: data?.periodo || "",
          })}
          formStructure={({ formValues, handleInputChange, setearValor }) => [
            {
                grid: {xs: 12, md: 6},
                Component: SelectValidatorGeneric,
                variant: 'outlined',
                label: 'Concepto',
                name: 'concepto',
                value: formValues?.conceptoSurge ? formValues?.conceptoSurge?.id : "",
                onChange: (e) => setearValor("conceptoSurge", surge.data.conceptos.find(item => item.id === e.target.value)),
                menuItems: surge.data.conceptos.map(item => ({
                    value: item.id,
                    label: item.descripcion
                })),
                validations: [required],
            },
            {
                grid: {xs: 12, md: 6},
                Component: SelectValidatorGeneric,
                variant: 'outlined',
                label: 'Resolución',
                name: 'resolucion',
                value: formValues?.resolucionSurge ? formValues?.resolucionSurge.id : "",
                onChange: (e) => setearValor("resolucionSurge", surge.data.resoluciones.find(item => item.id === e.target.value)),
                menuItems: surge.data.resoluciones.map(item => ({
                    value: item.id,
                    label: item.descripcion
                })),
                validations: [required],
            },
            {
                grid: {xs: 12, md: 6},
                Component: ValidatorInputField,
                variant: 'outlined',
                label: 'Valor',
                name: 'valor',
                value: formValues.valor,
                onChange: handleInputChange,
                type: 'number',
                validations: [required, onlyDecimals],
            },
            {
                grid: {xs: 12, md: 6},
                Component: ValidatorInputField,
                variant: 'outlined',
                label: 'Periodo (aaaamm)',
                name: 'periodo',
                value: formValues.periodo,
                type: 'number',
                onChange: (e) => {if(e.target.value.length <= 6) handleInputChange(e)},
                validations: [required, onlyNumbers, exactLength(6)],
            }
          ]}
          dataTable={{
            list: surge.data.practicasYDispositivos,
            columns: [
                {
                    label: "Concepto",
                    id: "conceptoSurge.descripcion",
                    sort: true
                },
                {
                    label: "Resolucion",
                    id: "resolucionSurge.descripcion",
                    sort: true
                },
                {
                    label: "Valor",
                    id: "valor",
                    customBody: (item) => `$${parseFloat(item.valor).toFixed(2)}`,
                    sort: true
                },
                {
                    label: "Periodo",
                    id: "periodo",
                    sort: true
                }
            ],
          }}
          submit={({id, ...values}, handleClose) => {
            if (!!id) surge.update.practicaYDispositivo(id, values, handleClose);
            else surge.insert.practicaYDispositivo(values, handleClose);
          }}
          deleteButton={(data, handleClose) => {
            surge.remove.practicaYDispositivo(data.idPracticaDispositivo, handleClose);
          }}
        />
      </div>
    );
  };
  